export const formatUSDCurrency = (value, fractionDigits = 2) => {
  if (!value) {
    value = '0'
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  })

  return formatter.format(value)
}

export const hasDisplayablePrice = (value) => {
  if (value === null || value === undefined) return false
  if (typeof value === 'string' && value.trim() === '') return false
  const num = Number(value)
  return Number.isFinite(num) && num > 0
}

export const strSlug = (str) => {
  return str?.toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')
}
